import React from 'react';

type BallState = 'idle' | 'thinking' | 'tool_calling' | 'streaming' | 'done';

interface KivoBallProps {
  state?: BallState;
  size?: number;
}

const PARTICLE_COUNT = 8;

const KivoBall: React.FC<KivoBallProps> = ({ state = 'idle', size = 50 }) => {
  return (
    <div
      className={`kivo-orb kivo-orb--${state}`}
      style={{ ['--orb-size' as string]: `${size}px` }}
      aria-hidden
    >
      <div className="kivo-orb__aura" />
      <div className="kivo-orb__aura kivo-orb__aura--lag" />
      <div className="kivo-orb__halo" />
      <div className="kivo-orb__body" />
      <div className="kivo-orb__orbit">
        {Array.from({ length: PARTICLE_COUNT }).map((_, i) => (
          <span key={i} style={{ ['--i' as string]: i }} />
        ))}
      </div>
    </div>
  );
};

export default KivoBall;
